import { useCallback, useEffect, useState } from "react";
import MenuCM from "components/shared/menu";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import ClearIcon from "@mui/icons-material/Clear";
import NotFound from "components/shared/NotFound/NotFound";
import { useForm } from "react-hook-form";
import LoadingCM from "components/shared/Loading";
import PaginationCM from "components/shared/Pagination";
import useHttp from "hooks/use-http";
import { Link, useNavigate, useParams } from "react-router-dom";
import Toast from "helper/toast";
import spliter from "helper/digit-spliter";
import {
  getCartRequest,
  deleteCartOrderRequest,
  addOrderRequest,
  addToCartRequest,
} from "api/requests";
import {
  AddProductWrapper,
  IconWrapper,
  StyledDeleteDiv,
  StyledFixedDivDescription,
  StyledFixedDivPrice,
  StyledImage,
  StyledImageDiv,
  StyledInput,
  StyledMainDivCount,
  StyledMainDivFlex,
  StyledMainDivImageAndInfo,
  StyledMainFixedButtonDeleteAllProduct,
  StyledMainFixedButtonNext,
  StyledMainFixedDiv,
  StyledMainFixedDiv2,
  StyledMainFixedPaper,
  StyledMainPaper,
  StyledProductInfoDiv,
  StyledProductPrice,
  StyledProductTitle,
} from "./ShoppingCart.style";
import { Container } from "@mui/material";
import ProductCard from "components/ProductCard";
import FooterCM from "components/shared/footer";
import SkeletonCM from "components/shared/Skeleton";
import LoadingPartCM from "components/shared/PartLoading";
import {Helmet} from "react-helmet";

export default function ShoppingCart() {
  const params = useParams();
  const navigate = useNavigate();
  const { request, loading, setLoading } = useHttp();
  const [orders, setOrders] = useState({
    count: 0,
    data: [],
    total_price: 0,
    message: "",
  });
  const [orderFirst, setorderFirst] = useState(false);
  const [cartInfo, setCartInfo] = useState({
    totalPrice: "",
  });
  const {
    register,
    handleSubmit,
    resetField,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const getOrders = async (search) => {
    const res = await request({
      url: getCartRequest,
      values: {
        skip: 0,
        limit: 100,
        search,
        userId: params.userId,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.product_color_id,
      product_color_id: items.product_color_id,
      quantity: items.quantity,
      colorTitle: items?.product_color?.title,
      color: items?.product_color?.color_code,
      title: items?.product_color?.product?.title,
      image: items?.product_color?.product?.image,
      price: items?.product_color?.product?.price,
    }));

    setOrders({
      data: transformedData,
      count: res.count,
      total_price: res.total_price,
      message: res.message,
    });

    if (res) {
      setorderFirst(true);
    }
  };

  const onSubmit = async (id, type) => {
    let counter = +getValues(`product${id}`);

    if (type === "increase") {
      setLoading(true);

      const res = await request({
        url: addToCartRequest,
        values: { id, quantity: 1, product_color_id: id.toString() },
        isMulty: true,
      });

      setLoading(false);
      if (res) {
        Toast({
          title: "محصول با موفقیت به سبد خرید اضافه شد",
          type: "custom-success",
        });
        setValue(`product${id}`, ++counter);
        getOrders();
      }
    }
    if (type === "decrease") {
      setLoading(true);
      const res = await request({
        url: addToCartRequest,
        values: { id, quantity: -1, product_color_id: id.toString() },
        isMulty: true,
      });
      setLoading(false);
      if (res) {
        Toast({
          title: "محصول با موفقیت از سبد خرید کم شد",
          type: "custom-success",
        });
        setValue(`product${id}`, --counter);
        getOrders();
      }
    }
  };

  var handelDelete = useCallback(
    async (id) => {
      const res = await request({
        url: deleteCartOrderRequest,
        values: id,
      });
      if (res) {
        getOrders();
        Toast({
          type: "success",
          title: "حذف  ",
        });
      }
    },
    [getOrders, request]
  );

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <>
      <Helmet>
        <title>سبد خرید - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading && orderFirst == false ? (
        <>
          <div
            style={{ width: "50%", padding: "10px", display: "inline-block" }}
          >
            <SkeletonCM Inline Height={120} BackWrapper />
          </div>
          <div
            style={{ width: "50%", padding: "10px", display: "inline-block" }}
          >
            <SkeletonCM Inline Height={120} />
          </div>
        </>
      ) : (
        ""
      )}
      <Box
        style={{
          marginBottom: orders.count == 0 ? "50px" : "160px",
          marginTop: "70px",
        }}
      >
        <>
          <MenuCM Background pageTitle="سبد خرید" />
          <Container>
            <Grid container direction="row">
              <>
                {orders.count == 0 ? (
                  loading ? (
                    ""
                  ) : (
                    <NotFound title="سبد خرید خالی است" />
                  )
                ) : (
                  <>
                    {orders.data.map((items, index) => (
                      <ProductCard
                        key={"orders" + index}
                        items={items}
                        index={index}
                        register={register}
                        onSubmit={(productId, type) =>
                          onSubmit(productId, type)
                        }
                        onDelete={(id) => handelDelete(id)}
                        LoadingPart={loading ? true : false}
                      />
                    ))}
                  </>
                )}
              </>
            </Grid>
          </Container>
          {orders.count == 0 ? (
            <FooterCM />
          ) : (
            <StyledMainFixedPaper elevation={6}>
              <StyledMainFixedDiv>
                <StyledFixedDivPrice>
                  جمع کل :{" "}
                  {loading ? (
                    <LoadingPartCM />
                  ) : (
                    spliter(orders.total_price) + "تومان"
                  )}
                </StyledFixedDivPrice>
                <StyledFixedDivDescription>
                  {orders.message}
                </StyledFixedDivDescription>
              </StyledMainFixedDiv>

              <StyledMainFixedDiv2>
                <Grid container spacing={2} direction="row">
                  <Grid item xs={12}>
                    <Link to="/payment">
                      <StyledMainFixedButtonNext variant="contained">
                        ادامه خرید
                      </StyledMainFixedButtonNext>
                    </Link>
                    <Link to="/">
                      <StyledMainFixedButtonDeleteAllProduct variant="outlined">
                        انصراف
                      </StyledMainFixedButtonDeleteAllProduct>
                    </Link>
                  </Grid>
                </Grid>
              </StyledMainFixedDiv2>
            </StyledMainFixedPaper>
          )}
        </>
      </Box>
    </>
  );
}
